import React, { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import './ThemeIcon.scss';

const ThemeIcon = ({ icon }) => {
    const { t } = useContext(LanguageContext);
    
    return (
        <div className='theme-icon'>
            <img src={icon} alt={t('altText.icon')} />
        </div>
    );
};

export default ThemeIcon;